import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { RoleType } from '../../shared/enums/role-type/role-type.module';
import { Router } from '@angular/router';
import { Jwt } from '../../models/jwt.model';

@Component({
  selector: 'app-empty',
  templateUrl: './empty.component.html',
  styleUrl: './empty.component.css'
})
export class EmptyComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router){ }

  ngOnInit(){
    const jwt: Jwt | null = this.authService.getJwt();
    if (jwt != null) {
      const role = jwt?.role ?? null;
      if(role != null && role == RoleType.ADMIN){
        this.router.navigate(['/admin/pages']);
      }
    }
  }
}
